<template>
  <div
    class="flex flex-col items-center justify-center h-screen relative"
    style="z-index: 0"
  >
    <div class="background-image absolute top-0 left-0 w-full h-full">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="absolute top-0 left-0"
        width="25%"
        height="80%"
        viewBox="0 0 364 663"
        fill="none"
      >
        <path
          opacity="0.25"
          :style="[
            requestedOrganization &&
            requestedOrganization.theme &&
            requestedOrganization.theme.primary_color
              ? { color: requestedOrganization.theme.primary_color }
              : { color: '#3AF080' },
          ]"
          d="M267.362 -79.865C440.933 58.1153 418.589 276.134 -125 662.037L-112.459 588.786C80.3826 483.411 543.488 156.388 267.362 -79.865Z"
          fill="#3AF080"
        />
      </svg>
      <svg
        width="25%"
        class="absolute top-0 left-0"
        height="80%"
        viewBox="0 0 359 712"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.25"
          :style="[
            requestedOrganization &&
            requestedOrganization.theme &&
            requestedOrganization.theme.primary_color
              ? { color: requestedOrganization.theme.primary_color }
              : { color: '#3AB373' },
          ]"
          d="M242.205 -54.4781C433.553 54.178 412.512 284.485 -3.71298 711.066L-49.466 657.06C128.403 528.009 546.143 144.727 242.205 -54.4781Z"
          fill="#3AB574"
        />
      </svg>

      <div
        class="absolute top-0 right-0 flex items-start justify-end h-full w-full pointer-events-none"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25%"
          class="absolute bottom-0 right-0"
          height="80%"
          viewBox="0 0 393 730"
          fill="none"
          preserveAspectRatio="none"
        >
          <path
            opacity="0.25"
            :style="[
              requestedOrganization &&
              requestedOrganization.theme &&
              requestedOrganization.theme.primary_color
                ? { color: requestedOrganization.theme.primary_color }
                : { color: '#3AF080' },
            ]"
            d="M124.182 792.144C-87.2325 652.363 -75.4235 422.517 533.234 0.413395L504.784 274C300.609 271.371 -191.118 542.494 124.182 792.144Z"
            fill="#3AF080"
          />
        </svg>
        <svg
          width="25%"
          class="absolute bottom-0 right-0"
          height="80%"
          viewBox="0 0 351 852"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.25"
            :style="[
              requestedOrganization &&
              requestedOrganization.theme &&
              requestedOrganization.theme.primary_color
                ? { color: requestedOrganization.theme.primary_color }
                : { color: '#3AB373' },
            ]"
            d="M133.691 902C-70.1671 781.302 -85.6564 533.98 408 0V84.0574C227.292 238.342 -193.581 691.318 133.691 902Z"
            fill="#3AB574"
          />
        </svg>
      </div>
    </div>
    <div class="flex flex-col items-center justify-center z-10 gap-4">
      <div v-if="!requestedOrganization">
        <Logo type="ICON_DARK" class="login-logo" />
      </div>
      <div v-else>
        <img
          :src="requestedOrganization.logo_url"
          alt="Coach Catalyst"
          class="login-logo"
        />
      </div>
      <div
        class="w-4 h-0.5 flex-shrink-0 my-4 self-center"
        :style="[
          requestedOrganization &&
          requestedOrganization.theme &&
          requestedOrganization.theme.primary_color
            ? { background: requestedOrganization.theme.primary_color }
            : { background: '#3AB373' },
        ]"
      ></div>
      <p class="login-p">Sign in to your account</p>
      <!-- <div v-if="!requestedOrganization">
        <label>Or</label
        ><label class="login-start-trail" @click="startTrialClick">
          start your {{ trialDays }}-day trial</label
        >
      </div> -->

      <form
        novalidate="novalidate"
        class="simple_form new_user w-full gap-4"
        id="new_user"
        action="/auth/sign_in"
        accept-charset="UTF-8"
        method="post"
      >
        <input name="utf8" type="hidden" value="✓" />
        <input
          type="hidden"
          name="authenticity_token"
          value="souGDZlQRnP5Vj2aQVd/u7cmlYco9Xhyo4ahMpaZmd+kKkZ4X18GljxG+bYZ6QgN5VrREfAgLAXVU4Ldkh1o1g=="
        />

        <fieldset
          class="flex flex-col items-center justify-center w-full gap-4"
        >
          <div class="input email shadow-none w-full">
            <label
              class="self-stretch justify-start text-text-primary text-sm font-medium font-['Inter']"
            >Email</label
            >
            <input
              tabindex="1"
              autofocus="autofocus"
              class="w-full self-stretch pl-3 pr-2 py-2 bg-surface-primary rounded-lg outline outline-1 outline-offset-[-0.50px] outline-border-secondary inline-flex justify-start items-center gap-2"
              type="email"
              v-model="email"
              placeholder="Email address"
            />
          </div>
          <div class="input password shadow-none">
            <label
              class="self-stretch justify-start text-text-primary text-sm font-medium font-['Inter']"
            >Password</label
            >
          <div class="relative w-full">
            <input
              tabindex="2"
              ref="passwordInput"
              class="w-full self-stretch pl-3 pr-8 py-2 bg-surface-primary rounded-lg outline outline-1 outline-offset-[-0.50px] outline-border-secondary inline-flex justify-start items-center gap-2"
              :type="showingPassword ? 'text' : 'password'"
              placeholder="Password"
              v-model="password"
              @keydown="keyPress"
            />
            <button
                type="button"
                class="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer text-current"
                @mousedown.prevent
                @click="passwordView"
                :aria-label="showingPassword ? 'Hide password' : 'Show password'"
                :aria-pressed="showingPassword.toString()"
            >
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  :class="showingPassword ? 'bi bi-eye-fill' : 'bi bi-eye-slash-fill'"
                  viewBox="0 0 16 16"
              >
                <template v-if="showingPassword">
                  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
                  <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/>
                </template>
                <template v-else>
                  <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z"/>
                  <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z"/>
                </template>
              </svg>
            </button>
          </div>
          </div>
          <div
            class="login-footer w-full flex flex-col items-center justify-center gap-4"
          >
            <div class="flex items-center justify-between w-full">
              <div>
                <input
                  type="checkbox"
                  class="mr-2 w-4 h-4 relative bg-surface-primary rounded border border-border-primary"
                  v-model="remember_me"
                />
                <label
                  class="self-stretch justify-start text-text-primary text-sm font-normal font-['Inter'] leading-tight"
                >Remember Me</label
                >
              </div>
              <a href="/auth/password/new">
                <label
                  :style="[
                    requestedOrganization &&
                    requestedOrganization.theme &&
                    requestedOrganization.theme.primary_color
                      ? { color: requestedOrganization.theme.primary_color }
                      : { color: '#3AB373' },
                  ]"
                  class="login-forgot justify-start text-text-theme text-sm font-medium font-['Inter'] leading-tight"
                >Forgot your password?</label
                >
              </a>
            </div>
            <input
              :style="[
                requestedOrganization &&
                requestedOrganization.theme &&
                requestedOrganization.theme.primary_color
                  ? {
                      'background-color':
                        requestedOrganization.theme.primary_color,
                    }
                  : { 'background-color': '#3AB373' },
              ]"
              type="button"
              @click="submit"
              value="Sign in"
              tabindex="4"
              class="btn button submit-button"
              data-disable-with="Log in"
            />
            <div
              class="w-4 h-0.5 flex-shrink-0 my-4 self-center bg-gray-500"
            ></div>
            <div
              class="self-stretch h-5 text-center justify-start"
              v-if="!requestedOrganization"
            >
              <span class="text-base font-normal font-['Inter']"
              >Don’t have an account? </span
              ><span
              class="text-base font-semibold font-['Inter'] cursor-pointer"
              @click="startTrialClick"
              :style="[
                  requestedOrganization &&
                  requestedOrganization.theme &&
                  requestedOrganization.theme.primary_color
                    ? { color: requestedOrganization.theme.primary_color }
                    : { color: '#3AB373' },
                ]"
            >Start a FREE {{trialDays}}-day trial</span
            >
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</template>

<script>

import ApiUrls from '../../api-url';
import { mapGetters, mapState } from 'vuex';
import getters from '../../stores/login-store/getters/login-getters';
import AuthenticationMixin from '../../authentication-mixin';
import Logo from '../../components/logos/Logo.vue';

export default {
  mixins: [ApiUrls, AuthenticationMixin],
  data() {
    return {
      email: '',
      password: '',
      remember_me: false,
      showingPassword: false,
    };
  },
  components: {
    Logo,
  },
  async created() {
    await this.getData();
  },
  computed: {
    ...mapState(['trialAmount', 'trialDays', 'requestedOrganization']),
    ...mapGetters(['LOGIN_FORM', 'SIGN_UP_CREATE_ACCOUNT']),
  },
  beforeCreate: function() {
    document.body.style.backgroundColor = '#F9FAFB';
  },
  methods: {
    async getData() {
      document.title = `New Device/Session | Coach Catalyst`;
    },
    startTrialClick() {
      this.$router.push({ name: 'SignupPage' });
    },
    keyPress(e) {
      if (e.keyCode === 13) {
        this.submit();
      }
    },
    async submit() {
      const formData = new FormData();
      formData.append('email', this.email);
      formData.append('password', this.password);
      formData.append('remember_me', this.remember_me);

      try {
        const { data } = await this.axiosInstance.post(`${this.authUrl}log_in`, formData);
        if (data.success) {
          window.location.href = data.redirect_uri;
        } else {
          this.$toast.show(data.result, this.toasted_options.error);
        }
      } catch {
        this.$toast.show(
          'Your account has been archived by your coach. Please contact them to reactivate and gain access.',
          this.toasted_options.error,
        );
      }
    },
    passwordView() {
      this.showingPassword = !this.showingPassword;
    },
  },
};
</script>

<style lang="scss"></style>
